import AvatarAction from './avatar-action';

export default AvatarAction;
